import config from '@/utils/config'
function dateFormat(val) {
	if (!val) {
		return ''
	} else {
		const s = (Number(val) - 621355968000000000) / 10000
		const date = new Date(s)
		let month = date.getMonth() + 1;
		let day = date.getDate();
		return date.getFullYear() + '-' + (month > 9 ? month : '0' + month) + '-' + (day > 9 ? day : '0' + day)
	}
}
function dateMonthDayFormat(val){
	if (!val) {
		return ''
	} else {
		const s = (Number(val) - 621355968000000000) / 10000
		const date = new Date(s)
		let month = date.getMonth() + 1;
		let day = date.getDate();
		let hour = date.getHours();
		let min = date.getMinutes();
		return (month > 9 ? month : '0' + month) + '-' + (day > 9 ? day : '0' + day) + ' ' + (hour > 9 ? hour : '0' + hour) + ':' + (min > 9 ? min : '0' + min)
	}
}
function dateTimeFormat(val) {
	if (!val) {
		return ''
	} else {
		const s = (Number(val) - 621355968000000000) / 10000
		const date = new Date(s)
		let month = date.getMonth() + 1;
		let day = date.getDate();
		let hour = date.getHours();
		let min = date.getMinutes();
		return date.getFullYear() + '-' + (month > 9 ? month : '0' + month) + '-' + (day > 9 ? day : '0' + day) + ' ' + (hour > 9 ? hour : '0' + hour) + ':' + (min > 9 ? min : '0' + min)
	}
}

function boolFormat(val) {
	if (val) {
		return '是'
	} else {
		return '否'
	}
}
function tenantStatusFormat(val) {
	return config.tenantStatus.find(r => r.value === val).name;
}
function orderStatusFormat(val) {
	return config.orderStatus.find(r => r.value === val).name;
}
function memberTypeFormat(val) {
	return config.memberTypes.find(r => r.value === val).name;
}

function channelFormat(val) {
	return config.channels.find(r => r.value === val).name;
}

export default {
	dateFormat,
	dateTimeFormat,
	dateMonthDayFormat,
	boolFormat,
	orderStatusFormat,
	memberTypeFormat,
	tenantStatusFormat,
	channelFormat
}


